import { BeneficiaryDetails } from 'types/beneficiaries'
import { SourceWallet } from 'types/move/move'
import { PayoutInstructionTypes, PayoutRequest } from 'types/unifiedPayouts/unifiedPayouts'
import { FiatSendFormData } from './form/fiatSendFormSchema'

export const getFirstPartyUnifiedPayoutRequest = (
  formValues: FiatSendFormData,
  selectedWallet: SourceWallet,
  fiatBeneficiary: BeneficiaryDetails
): PayoutRequest => {
  return {
    walletId: selectedWallet?.walletId,
    amount: {
      value: formValues?.amount,
      currency: selectedWallet?.currency,
    },
    paymentReference: formValues?.paymentReference,
    instruction: {
      type: PayoutInstructionTypes?.FIAT,
      beneficiary: {
        reference: fiatBeneficiary?.reference,
      },
    },
  }
}
